<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white card-zoom" 
  @mouseover="zoomIn" @mouseleave="zoomOut">
  <router-link to="/general">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Students in each course
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Number of Students
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 pt-8 flex-auto ">
      <div class="flex flex-wrap">
        
          <div class="w-full lg:w-3/12 px-4 mr-auto mb-2 pt-6 pb-6 shadow-lg rounded-lg border-0" style="--tw-bg-opacity: 1;background-color:#05585C;">
            <h2 class="text-blueGray text-xl font-semibold text-white">
              Doctor of Medicine Program
            </h2>
            <h2 class="text-blueGray text-base pt-2 pb-10  text-white">
              A Total of {{doctor_sum}} Students
            </h2>
            <div class="w-full lg:w-12/12 px-4 pt-2 pb-2 text-center shadow-lg rounded border-0" style="--tw-bg-opacity: 1;background-color:#fff;">
              <h2 class="text-blueGray text-base font-semibold text-blueGray">
                <i class="fa fa-male mr-2" aria-hidden="true"></i>Male {{student_arr.doctor_m}} | <i class="fa fa-female mr-2" aria-hidden="true"></i>Female {{student_arr.doctor_f}} 
              </h2>
            </div>
          </div>

          <div class="w-full lg:w-3/12 px-4 mr-auto mb-2 pt-6 pb-6 shadow-lg rounded-lg border-0" style="--tw-bg-opacity: 1;background-color:#089790;">
            <h2 class="text-blueGray text-xl font-semibold text-white">
              Bachelor of Science
            </h2>
            <h2 class="text-blueGray text-base pt-2 text-white">
              Radiological Technology 
            </h2>
            <h2 class="text-blueGray text-base pt-2 pb-6  text-white">
              A Total of {{student_arr.radio}} Students
            </h2>
            <div class="w-full lg:w-12/12 px-4 pt-2 pb-2 text-center shadow-lg rounded border-0" style="--tw-bg-opacity: 1;background-color:#fff;">
              <h2 class="text-blueGray text-base font-semibold text-blueGray">
                <i class="fa fa-male mr-2" aria-hidden="true"></i>Male {{student_arr.radio_m}} | <i class="fa fa-female mr-2" aria-hidden="true"></i>Female {{student_arr.radio_f}} 
              </h2>
            </div>
          </div>

          <div class="w-full lg:w-3/12 px-4 mr-auto mb-2 pt-6 pb-6 shadow-lg rounded-lg border-0" style="--tw-bg-opacity: 1;background-color:#6EC6CA;">
            <h2 class="text-blueGray text-xl font-semibold text-blueGray">
              Bachelor of Science
            </h2>
            <h2 class="text-blueGray text-base pt-2 text-blueGray">
              Physical Therapy 
            </h2>
            <h2 class="text-blueGray text-base pt-2 pb-6  text-blueGray">
              A Total of {{student_arr.therapy}} Students
            </h2>
            <div class="w-full lg:w-12/12 px-4 pt-2 pb-2 text-center shadow-lg rounded border-0" style="--tw-bg-opacity: 1;background-color:#fff;">
              <h2 class="text-blueGray text-base font-semibold text-blueGray">
                <i class="fa fa-male mr-2" aria-hidden="true"></i>Male {{student_arr.therapy_m}} | <i class="fa fa-female mr-2" aria-hidden="true"></i>Female {{student_arr.therapy_f}}
              </h2>
            </div>
          </div>

          <div class="w-full lg:w-3/12 px-4 mb-2 pt-6 pb-6 shadow-lg rounded-lg border-0" style="--tw-bg-opacity: 1;background-color:#A9DFE2;">
            <h2 class="text-blueGray text-xl font-semibold text-blueGray">
              Bachelor of Science
            </h2>
            <h2 class="text-blueGray text-base pt-2 text-blueGray">
              Emergency Medical Operation
            </h2>
            <h2 class="text-blueGray text-base pt-2 pb-6  text-blueGray">
              A Total of {{student_arr.student_arr}} Students
            </h2>
            <div class="w-full lg:w-12/12 px-4 pt-2 pb-2 text-center shadow-lg rounded border-0" style="--tw-bg-opacity: 1;background-color:#fff;">
              <h2 class="text-blueGray text-base font-semibold text-blueGray">
                <i class="fa fa-male mr-2" aria-hidden="true"></i>Male {{student_arr.er_m}} | <i class="fa fa-female mr-2" aria-hidden="true"></i>Female {{student_arr.er_f}}
              </h2>
            </div>
          </div>

        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import api from './../../services/student_services';
export default {
  name: "card-stats",
   data() {
        return {
            openTab: 1,
            student_arr: [],
            doctor_sum:[],
        }
    },
  methods: {
    zoomIn() {
      this.$el.style.transform = "scale(1.05)";
    },
    zoomOut() {
      this.$el.style.transform = "scale(1)";
    },
     async student() {

            api.student().then(async (result) => {

                this.student_arr = result.data;
                this.doctor_sum = (parseInt(this.student_arr.doctor_f) + parseInt(this.student_arr.doctor_m)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;
                this.sci_sum = (parseInt(this.student_arr.sci_f) + parseInt(this.student_arr.sci_m)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;

                this.doctor = (parseInt(this.student_arr.doctor) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.doctor_m = (parseInt(this.student_arr.doctor_m) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.doctor_f = (parseInt(this.student_arr.doctor_f) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 

                this.radio = (parseInt(this.student_arr.radio) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.radio_m = (parseInt(this.student_arr.radio_m) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.radio_f = (parseInt(this.student_arr.radio_f) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 

                this.therapy = (parseInt(this.student_arr.therapy) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.therapy_m = (parseInt(this.student_arr.therapy_m) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.therapy_f = (parseInt(this.student_arr.therapy) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 

                this.er = (parseInt(this.student_arr.er) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.er_m = (parseInt(this.student_arr.er_m) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 
                this.er_f = (parseInt(this.student_arr.er_f) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ; 

               // doctor_sum = student_arr.doctor_f + student_arr.doctor_f;
                
            });

        },
          
  },
   created: async function () {
        await this.student()
    },
};
</script>